import { GameConfigSchema } from "slotworks/config/game-config-schema";
import { SymbolConfig } from "slotworks/config/game-config-schema";
import betModel from "slotworks/model/bets/bet-model";
import SymbolDefinition from "slotworks/model/symbol-definition";
import Point from "slotworks/utils/geom/point";
import ValueList from "slotworks/utils/value-list";

class SlotDefinition {
    public reelsets: Map<string, string[][]>;

    public lines: ValueList<Point[]> = new ValueList();

    public matrixGrid: number[];

    public symbolDefinitions: SymbolDefinition[];

    public bestSymbol: SymbolDefinition;

    private highestSymbolPayout: number = 0;

    public processConfig(gameConfig: GameConfigSchema) {
        betModel.creditSizes.values = gameConfig.creditSizes;
        betModel.creditsPerLine.values = gameConfig.creditsPerLine;
        this.processLines(gameConfig.lines);

        this.processMatrixGrid(gameConfig.matrixGrid);

        this.processSymbols(gameConfig.symbols);
        this.processReelSets(gameConfig.reelsets);
    }

    public getSymbolDefinition(id: string): SymbolDefinition {
        for (const symbol of this.symbolDefinitions) {
            if (symbol.id === id) {
                return symbol;
            }
        }
        throw new Error("Symbol in aperture response which isn't found in symbolDefinitions: " + id);
    }

    private processLines(lines: number[][]) {
        this.lines.values = [];
        for (const line of lines) {

            const lineDefinition = [];
            let x = 0;

            for (const position of line) {
                lineDefinition.push(new Point(x, position));
                x++;
            }

            this.lines.values.push(lineDefinition);
        }
    }

    private processReelSets(reelsets: { [id: string]: number[][] }) {
        this.reelsets = new Map<string, string[][]>();

        for (const reelsetId in reelsets) {

            if (reelsets.hasOwnProperty(reelsetId)) {
                const reelset = reelsets[reelsetId];

                const parsedReelset = [];

                for (const reel of reelset) {

                    const parsedReel: string[] = [];
                    parsedReelset.push(parsedReel);

                    for (const symbolId of reel) {
                        parsedReel.push(this.symbolDefinitions[symbolId].id);
                    }
                }

                this.reelsets.set(reelsetId, parsedReelset);
            }
        }
    }

    private processMatrixGrid(matrixGrid: number[]) {
        this.matrixGrid = matrixGrid;
    }

    private processSymbols(symbols: SymbolConfig[]) {
        this.symbolDefinitions = [];
        this.bestSymbol = null;
        this.highestSymbolPayout = 0;

        for (const symbol of symbols) {
            const symbolDef = new SymbolDefinition(symbol);
            this.symbolDefinitions.push(symbolDef);

            // Helpfully keep a reference to the highest paying symbol
            if (symbolDef.payouts) {
                symbolDef.payouts.forEach((value: number) => {
                    if (value > this.highestSymbolPayout) {
                        this.highestSymbolPayout = value;
                        this.bestSymbol = symbolDef;
                    }
                });
            }
        }
    }
}

export default new SlotDefinition();
